<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-radio-group v-model="statisticsTime" size="small">
          <el-radio-button
            :value="value.id"
            :label="value.id"
            v-for="value in $store.state.select.statisticsTimeList"
            :key="value.id"
            >{{ value.name }}</el-radio-button
          >
        </el-radio-group>
      </div>

      <div class="search_box">
        <div v-if="statisticsTime == 0">
          <el-date-picker
            class="select-date"
            size="small"
            :picker-options="pickerOptions"
            v-model="selectYear"
            value-format="timestamp"
            type="year"
            placeholder="选择年"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div v-if="statisticsTime == 1">
          <el-select
            class="select-date"
            size="small"
            v-model="selectQuarter"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, key) in quarterInitialization"
              :disabled="item.disable"
              :key="key"
              :label="item.dateName"
              :value="item.dateNumber"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="statisticsTime == 2">
          <el-date-picker
            class="select-date"
            size="small"
            :picker-options="pickerOptions"
            value-format="timestamp"
            v-model="selectMonth"
            type="month"
            placeholder="选择月"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div v-if="statisticsTime == 3">
          <el-date-picker
            class="select-date"
            size="small"
            v-model="selectWeek"
            type="week"
            format="yyyy 第 WW 周"
            :picker-options="pickerOptions"
            placeholder="选择周"
            :clearable="false"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="inside_pages_right">
      <div class="data-info">
        <div class="info-content">
          <div class="statistics_row_one">
            <div class="duty_item">
              <img
                class="duty_item_img"
                src="@/assets/img/statistics/notice-num.png"
                alt=""
              />
              <div class="duty_item_text">
                <div class="duty_item_num">
                  {{ responseData.noticeTotal }}
                </div>
                <div class="duty_item_tips">通知总数</div>
              </div>
            </div>
            <div class="duty_item">
              <img
                class="duty_item_img"
                src="@/assets/img/statistics/notice-top.png"
                alt=""
              />
              <div class="duty_item_text">
                <div class="duty_item_num">
                  {{ responseData.external }}
                </div>
                <div class="duty_item_tips">上级通知</div>
              </div>
            </div>
            <div class="duty_item">
              <img
                class="duty_item_img"
                src="@/assets/img/statistics/notice.png"
                alt=""
              />
              <div class="duty_item_text">
                <div class="duty_item_num">
                  {{ responseData.inside }}
                </div>
                <div class="duty_item_tips">校内通知</div>
              </div>
            </div>
          </div>
          <notification-statistics-chart
            :echartsData="responseData.dataList"
            :title="title"
          ></notification-statistics-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationStatisticsChart from "./components/NotificationStatisticsChart";
export default {
  name: "",
  components: {
    NotificationStatisticsChart
  },
  props: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      statisticsTime: -1,
      selectYear: "",
      selectQuarter: -1,

      selectMonth: "",

      selectWeek: "",

      timeList: [],

      // 初始化季度
      quarterInitialization: [],
      requestData: {
        schoolId: this.$store.state.schoolId,
        type: 0,
        startTime: 0,
        endTime: 0
      },
      responseData: {
        noticeTotal: 0,
        inside: 0,
        external: 0,
        dataList: []
      },
      title: "校际通知波段图",
      // 校内通知
      insideList: [],
      // 上级通知
      externalList: [],

      monthList: [
        "2020.01",
        "2020.02",
        "2020.03",
        "2020.04",
        "2020.05",
        "2020.06",
        "2020.07"
      ]
    };
  },
  watch: {
    statisticsTime() {
      this.requestData.type = this.statisticsTime;
      this.quarterInitialization = this.$Common.createQuarterTwo();
      var times = this.$Common.getPartTimeStamp();
      switch (this.statisticsTime) {
        case 0:
          this.selectYear = times.yearTime;
          this.selectQuarter = -1;
          break;
        case 1:
          this.selectQuarter = times.quarterTime;
          break;
        case 2:
          this.selectQuarter = -1;
          this.selectMonth = times.monthTime;
          break;
        case 3:
          this.selectQuarter = -1;
          this.selectWeek = times.weekTime;
          break;
      }
    },
    // 选择年
    selectYear() {
      if (this.statisticsTime == 0) {
        var resultsObj = this.$Common.getYearTime(this.selectYear);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },
    // 选择季度
    selectQuarter() {
      if (this.statisticsTime == 1) {
        // console.log(111)
        var thisQuarter = this.selectQuarter;
        var resultsObj = this.$Common.getQuarterTime(thisQuarter);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },
    // 选择月
    selectMonth() {
      if (this.statisticsTime == 2) {
        var resultsObj = this.$Common.getMonthTime(this.selectMonth);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },

    // 选择星期
    selectWeek() {
      if (this.statisticsTime == 3) {
        var resultsObj = this.$Common.getWeekTime(this.selectWeek);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    }
  },
  computed: {},
  methods: {
    // 获取统计数据
    async getStatisticalData() {
      var newParamData = this.requestData;
      if (Object.is(newParamData.endTime, NaN)) {
        this.$message("请选择时间！");
        return;
      }
      // console.log(newParamData.type)
      // console.log(newParamData.startTime+'---------'+this.$Common.dateFormatDateTwo(newParamData.startTime))
      // console.log(newParamData.endTime+'---------'+this.$Common.dateFormatDateTwo(newParamData.endTime))
      let res = await this.$Http.noticeStatistics(newParamData);
      if (res.code == 200) {
        this.responseData.noticeTotal = res.data.noticeInfo.noticeTotal;
        this.responseData.inside = res.data.noticeInfo.inside;
        this.responseData.external = res.data.noticeInfo.external;

        this.responseData.dataList = res.data.noticeStatistics;
        this.timeList = [];
        this.insideList = [];
        this.externalList = [];
        this.responseData.dataList.forEach((element) => {
          this.timeList.push(element.ym);
          this.insideList.push(element.inside);
          this.externalList.push(element.external);
        });
        // console.log(res.data)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {
    this.statisticsTime = 0;
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.inside_pages_right {
  background: #f5f5f7ff;
  height: calc(100% - 70px);
  .inside_pages_right_top {
    background: #fff;
  }
  .statistics_top {
    padding: 10px 150px;
    background: #fff;
    .select-date {
      width: 158px;
    }
  }

  .data-info {
    margin-top: 8px;
    padding: 30px 150px;
    background: #fff;
    height: calc(100% - 10px);
    .info-content {
      // position: relative;
      background: #ffffff;
      box-shadow: 0px 0px 22px 0px rgba(229, 229, 229, 0.59);
      border-radius: 2px;
      height: 100%;
    }
  }
  .statistics_row_one {
    margin: 0;
    padding: 40px 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-bottom: none;
    width: 100%;
    // position: absolute;
    // top: 20px;
    // right: ;
    .statistics-item {
      width: 100%;
      max-width: 926px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .duty_item {
      flex: 1 1 80px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      &:before {
        content: "";
        width: 100%;
        height: 2px;
        background: #eff9ff;
        position: absolute;
        top: 56px;
        left: 0;
        right: 0;
      }
      &:after {
        content: "";
        width: 7px;
        height: 7px;
        background: #c5e6f9;
        border-radius: 50%;
        box-shadow: 0px 1px 4px 0px rgba(64, 107, 132, 0.27);
        position: absolute;
        top: 53.5px;
        left: 50%;
        right: 0;
        margin-left: -3.5px;
      }
    }
    .duty_item_img {
      width: 43px;
      height: 46px;
    }
    .duty_item_text {
      padding-top: 20px;
    }
    .duty_item_num {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7a7a7a;
      letter-spacing: 1px;
    }
    .duty_item_tips {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303030;
    }
  }
}
</style>
